import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FormControl } from '@angular/forms';

import { SortOrder } from '@common/utils/search-sort';
import { Device } from '@store/state/devices.state';

import { SearchParams, SortParams } from '../app/portal/pages/monitoring-page/monitoring.types';

@Injectable({
  providedIn: 'root',
})
export class DevicesService {
  private readonly httpClient = inject(HttpClient);

  devicesListSortParams: SortParams = {
    sortState: SortOrder.Asc,
    sortProp: new FormControl<string>('name', { nonNullable: true }),
    nullsPosition: new FormControl<'first' | 'last'>('last', {
      nonNullable: true,
    }),
  };
  devicesListSearchParams: SearchParams = {
    searchControl: new FormControl<string>('', { nonNullable: true }),
    filterCriteria: {},
    filterModeControl: new FormControl('any', { nonNullable: true }),
    matchModeControl: new FormControl('includes', {
      nonNullable: true,
    }),
    caseSensitive: false,
  };

  listModels() {
    return this.httpClient.get<{ id: number; name: string }[]>('device/models/');
  }

  createDevice(body: any) {
    return this.httpClient.post('devices/', body);
  }

  updateDevice(deviceId: number, body: any) {
    return this.httpClient.put(`devices/${deviceId}/`, body);
  }

  deleteDevice(deviceId: number) {
    return this.httpClient.delete(`devices/${deviceId}/`);
  }

  list() {
    return this.httpClient.get<Device[]>('devices/');
  }
}
